import Vue from "vue";
import Router from "vue-router";

import Welcome from "./views/Welcome.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";

import Profile from "./views/Profile.vue";
import Scales from "./views/Scales.vue";
import ScaleShowCreateEdit from "./views/ScaleShowCreateEdit.vue";

import Waist from "./views/Waist.vue";
import WaistShowCreateEdit from "./views/WaistShowCreateEdit.vue";

import Weight from "./views/Weight.vue";
import WeightShowCreateEdit from "./views/WeightShowCreateEdit.vue";

import BloodSugar from "./views/BloodSugar.vue";
import BloodSugarShowCreateEdit from "./views/BloodSugarShowCreateEdit.vue";

import BloodPressure from "./views/BloodPressure.vue";
import BloodPressureShowCreateEdit from "./views/BloodPressureShowCreateEdit.vue";

import VersionHistory from "./views/VersionHistory.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "welcome",
      component: Welcome

      // beforeEnter: (to, from, next) => {

      //   if (to.path == "/" && (Vue.auth != null) && Vue.auth.ready() && Vue.auth.check()) {
      //     next("/profile");
      //   }
      //   else {
      //     next();
      //   }
      // }
    },
    {
      path: "/login",
      name: "login",
      meta: { auth: false },
      component: Login
    },
    {
      path: "/register",
      name: "register",
      meta: { auth: false },
      component: Register
    },
    {
      path: "/profile",
      name: "profile",
      meta: { auth: true },
      component: Profile
    },
    {
      path: "/waist",
      name: "waist",
      meta: { auth: true },
      component: Waist
    },
    {
      path: "/waist/list",
      name: "waist.list",
      meta: { auth: true },
      component: Waist
    },
    {
      path: "/waist/chart",
      name: "waist.chart",
      meta: { auth: true },
      component: Waist
    },
    {
      path: "/waist/create",
      name: "waist.create",
      meta: { auth: true },
      component: WaistShowCreateEdit
    },
    {
      path: "/waist/:id",
      name: "waist.show",
      meta: { auth: true },
      component: WaistShowCreateEdit,
      props: true
    },
    {
      path: "/waist/:id/edit",
      name: "waist.edit",
      meta: { auth: true },
      component: WaistShowCreateEdit,
      props: true
    },
    {
      path: "/weight",
      name: "weight",
      meta: { auth: true },
      component: Weight
    },
    {
      path: "/weight/list",
      name: "weight.list",
      meta: { auth: true },
      component: Weight
    },
    {
      path: "/weight/chart",
      name: "weight.chart",
      meta: { auth: true },
      component: Weight
    },
    {
      path: "/weight/scales",
      name: "weight.scales",
      meta: { auth: true },
      component: Weight
    },
    {
      path: "/weight/scales/:id",
      name: "scales.show",
      meta: { auth: true },
      component: ScaleShowCreateEdit
    },
    {
      path: "/weight/scales/create",
      name: "scales.create",
      meta: { auth: true },
      component: ScaleShowCreateEdit
    },
    {
      path: "/weight/scales/:id/edit",
      name: "scales.edit",
      meta: { auth: true },
      component: ScaleShowCreateEdit
    },
    {
      path: "/weight/create",
      name: "weight.create",
      meta: { auth: true },
      component: WeightShowCreateEdit
    },
    {
      path: "/weight/:id",
      name: "weight.show",
      meta: { auth: true },
      component: WeightShowCreateEdit,
      props: true
    },
    {
      path: "/weight/:id/edit",
      name: "weight.edit",
      meta: { auth: true },
      component: WeightShowCreateEdit,
      props: true
    },
    {
      path: "/blood-sugar",
      name: "blood-sugar",
      meta: { auth: true },
      component: BloodSugar
    },
    {
      path: "/blood-sugar/list",
      name: "blood-sugar.list",
      meta: { auth: true },
      component: BloodSugar
    },
    {
      path: "/blood-sugar/chart",
      name: "blood-sugar.chart",
      meta: { auth: true },
      component: BloodSugar
    },
    {
      path: "/blood-sugar/create",
      name: "blood-sugar.create",
      meta: { auth: true },
      component: BloodSugarShowCreateEdit
    },
    {
      path: "/blood-sugar/:id",
      name: "blood-sugar.show",
      meta: { auth: true },
      component: BloodSugarShowCreateEdit,
      props: true
    },
    {
      path: "/blood-sugar/:id/edit",
      name: "blood-sugar.edit",
      meta: { auth: true },
      component: BloodSugarShowCreateEdit,
      props: true
    },
    {
      path: "/blood-pressure",
      name: "blood-pressure",
      meta: { auth: true },
      component: BloodPressure
    },
    {
      path: "/blood-pressure/list",
      name: "blood-pressure.list",
      meta: { auth: true },
      component: BloodPressure
    },
    {
      path: "/blood-pressure/chart",
      name: "blood-pressure.chart",
      meta: { auth: true },
      component: BloodPressure
    },
    {
      path: "/blood-pressure/create",
      name: "blood-pressure.create",
      meta: { auth: true },
      component: BloodPressureShowCreateEdit
    },
    {
      path: "/blood-pressure/:id",
      name: "blood-pressure.show",
      meta: { auth: true },
      component: BloodPressureShowCreateEdit,
      props: true
    },
    {
      path: "/blood-pressure/:id/edit",
      name: "blood-pressure.edit",
      meta: { auth: true },
      component: BloodPressureShowCreateEdit,
      props: true
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/versionhistory",
      name: "versionhistory",
      component: VersionHistory
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.path == "/" && Vue.auth.ready() && Vue.auth.check()) {
//     next("/profile");
//   }
//   else {
//     next();
//   }
// })

export default router;
